import React from "react";

const InitialsField = ({
    FormData,
    Para,
    id,
    value,
    onChange,
    isInvalid = false,
    required = false,
    disabled = false
}) => {
    const requiredInitials = `${FormData.first_name?.[0] || ""}${FormData.last_name?.[0] || ""}`.toUpperCase();

    return (
        <div className={`p-3 rounded  ${isInvalid ? 'border border-red-500 bg-red-50' : ''}`}>
            <div className="flex items-start gap-2 flex-wrap">
                <input
                    type="text"
                    id={id}
                    value={value || ""}
                    onInput={(e) => {
                        const newValue = e.target.value.slice(0, 2).toUpperCase();
                        onChange && onChange(id, newValue);
                    }}
                    placeholder={`${requiredInitials}`}
                    maxLength="2"
                    disabled={disabled}
                    className={`w-16 px-2 py-1 border rounded text-center text-lg uppercase flex-shrink-0 placeholder-gray-400 ${
                        value ? 'font-bold' : 'font-normal'
                    } ${
                        isInvalid
                            ? 'border-red-500 bg-red-100 focus:ring-red-500'
                            : 'border-gray-300 focus:ring-blue-500'
                    } focus:outline-none focus:ring-2`}
                />
                <p className="text-sm text-gray-700 flex-1">{Para}</p>
            </div>
            {isInvalid && (
                <p className="text-red-600 text-xs mt-2">Initials are required</p>
            )}
        </div>
    );
};

export default InitialsField;
